import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'CalendarCheck';
const IconTitle = 'Calendar check';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5762 13.2302C15.8413 12.9119 15.7983 12.439 15.4801 12.1739C15.1619 11.9087 14.689 11.9517 14.4238 12.2699L11.1996 16.139L9.53033 14.4697C9.23744 14.1768 8.76256 14.1768 8.46967 14.4697C8.17678 14.7626 8.17678 15.2375 8.46967 15.5303L10.7197 17.7803C10.8687 17.9294 11.0735 18.0088 11.284 17.9992C11.4945 17.9897 11.6913 17.892 11.8262 17.7302L15.5762 13.2302Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 3.75C9 3.33579 8.66421 3 8.25 3C7.83579 3 7.5 3.33579 7.5 3.75V4.5H5.25C4.00736 4.5 3 5.50736 3 6.75V18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75V6.75C21 5.50736 19.9926 4.5 18.75 4.5H16.5V3.75C16.5 3.33579 16.1642 3 15.75 3C15.3358 3 15 3.33579 15 3.75V4.5H9V3.75ZM5.25 6H7.5V6.75C7.5 7.16421 7.83579 7.5 8.25 7.5C8.66421 7.5 9 7.16421 9 6.75V6H15V6.75C15 7.16421 15.3358 7.5 15.75 7.5C16.1642 7.5 16.5 7.16421 16.5 6.75V6H18.75C19.1642 6 19.5 6.33579 19.5 6.75V9H4.5V6.75C4.5 6.33579 4.83579 6 5.25 6ZM4.5 10.5H19.5V18.75C19.5 19.1642 19.1642 19.5 18.75 19.5H5.25C4.83579 19.5 4.5 19.1642 4.5 18.75V10.5Z" fill="currentColor"/>
  </svg>
`;

const CalendarCheckIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      d='M15.5762 13.2302C15.8413 12.9119 15.7983 12.439 15.4801 12.1739C15.1619 11.9087 14.689 11.9517 14.4238 12.2699L11.1996 16.139L9.53033 14.4697C9.23744 14.1768 8.76256 14.1768 8.46967 14.4697C8.17678 14.7626 8.17678 15.2375 8.46967 15.5303L10.7197 17.7803C10.8687 17.9294 11.0735 18.0088 11.284 17.9992C11.4945 17.9897 11.6913 17.892 11.8262 17.7302L15.5762 13.2302Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 3.75C9 3.33579 8.66421 3 8.25 3C7.83579 3 7.5 3.33579 7.5 3.75V4.5H5.25C4.00736 4.5 3 5.50736 3 6.75V18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75V6.75C21 5.50736 19.9926 4.5 18.75 4.5H16.5V3.75C16.5 3.33579 16.1642 3 15.75 3C15.3358 3 15 3.33579 15 3.75V4.5H9V3.75ZM5.25 6H7.5V6.75C7.5 7.16421 7.83579 7.5 8.25 7.5C8.66421 7.5 9 7.16421 9 6.75V6H15V6.75C15 7.16421 15.3358 7.5 15.75 7.5C16.1642 7.5 16.5 7.16421 16.5 6.75V6H18.75C19.1642 6 19.5 6.33579 19.5 6.75V9H4.5V6.75C4.5 6.33579 4.83579 6 5.25 6ZM4.5 10.5H19.5V18.75C19.5 19.1642 19.1642 19.5 18.75 19.5H5.25C4.83579 19.5 4.5 19.1642 4.5 18.75V10.5Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconTitle,

  IconComponent: CalendarCheckIcon,
  IconSvg: IconSvg
} as IconType;
